import { useTodaysPhrase } from '@/lib/collections/phrases/hookPhrases';
import { Button } from '@/components/ui/button';
import React from 'react';
import { Quote } from 'lucide-react';

interface PhraseOfTheDayProps {
  className?: string;
}

const PhraseOfTheDay: React.FC<PhraseOfTheDayProps> = ({ className }) => {
  const { phrase, loading, error, refreshPhrase } = useTodaysPhrase();

  if (loading) {
    return (
      <div className={`bg-white dark:bg-gradient-to-r font-outfit dark:from-zinc-800 dark:to-zinc-900 dark:text-white shadow-sm dark:shadow-zinc-900/25 border border-gray-100 dark:border-zinc-700/50 rounded-4xl p-4 md:p-6 animate-pulse ${className}`}>
        <div className="h-4 bg-gray-100 dark:bg-white/20 rounded w-3/4 mb-2"></div>
        <div className="h-3 bg-gray-100 dark:bg-white/20 rounded w-1/2"></div>
      </div>
    );
  }

  if (error || !phrase) {
    return (
      <div className={`bg-red-500 text-white rounded-xl p-3 ${className}`}>
        <p className="text-sm">{error || 'No se pudo cargar la frase del día'}</p>
        <Button
          onClick={refreshPhrase}
          size="sm"
          variant="destructive"
          className="mt-2"
        >
          Reintentar
        </Button>
      </div>
    );
  }

  //   return (
  //     <div className={`bg-gradient-to-r font-outfit from-indigo-200 to-purple-300 dark:from-zinc-800 dark:to-zinc-900 text-gray-700 dark:text-white rounded-4xl p-4 md:p-6  ${className}`}>
  //       {/* Header */}
  //       <div className="relative mb-2">
  //         {/* <h3 className="text-xs text-zinc-700 dark:text-white font-medium tracking-wide">
  //           ✨ Frase del Día
  //         </h3> */}
  //         <span className="absolute top-8 right-0 p-1 bg-white/10 rounded-full">
  //           <Quote className='text-gray-200 w-8 h-8' />
  //         </span>
  //       </div>

  //       {/* Content */}
  //       <blockquote className="italic font-extralight text-sm leading-tight dark:text-gray-300 font-outfit mb-2">
  //         "{phrase.phrase}"
  //       </blockquote>

  //       {/* Footer */}
  //       <cite className="text-xs opacity-90 font-light dark:text-gray-300">— {phrase.author}</cite>
  //     </div>
  //   );
  // };

  return (
    <div className={`bg-white dark:bg-gradient-to-r font-outfit dark:from-zinc-800 dark:to-zinc-900 dark:text-white shadow-sm dark:shadow-zinc-900/25 border border-gray-100 dark:border-zinc-700/50 rounded-4xl p-4 md:p-6 ${className}`}>
      <div className="relative mb-2">
        {/* <h3 className="text-xs text-zinc-700 dark:text-white font-medium tracking-wide">
          ✨ Frase del Día
        </h3> */}
        <span className="absolute -top-1 left-3 text-slate-200 dark:text-gray-600 opacity-40 dark:opacity-12">
          <Quote className='w-15 h-15' />
        </span>
      </div>

      {/* Content */}
      <blockquote className=" font-light font-outfit break-words text-sm md:text-base leading-relaxed text-gray-700 dark:text-gray-300  mb-1 text-left pr-2">
        "{phrase.phrase}"
      </blockquote>

      {/* Footer */}
      <cite className="text-xs md:text-sm opacity-70 font-light font-outfit text-gray-600 dark:text-gray-400 text-right block ml-auto">

        — {phrase.author}
      </cite>
    </div>
  );
};
export default PhraseOfTheDay;